import { Component, Input, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { Checklist } from '../../models/checklist.model';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent implements OnInit {
  @Input() data: any;
  numberOfChecked = 0;
  checkedPercentage = 0;

  constructor(
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.getChecklistProgress();
  }

  checkboxChange($event: MatCheckboxChange) {

  }

  getChecklistProgress() {
    let checked = 0;

    this.data.list.forEach(element => {
      if (element.checked) {
        checked++;
      }
    });
    
    this.numberOfChecked = checked;
    this.checkedPercentage = (this.numberOfChecked/this.data.list.length) * (100/1);
  }

  openPdfViewerDialog(url: string, signatureRequired: boolean) {
    if (url) {
      window.open(url, '_blank');
    } else {
      this.snackbarService.openSnackBar('No document was available to preview.', 'clear', 'warn');
    }
  }

}
